import './i18n.jsx'
import 'window.jsx'

import React      from 'react'
import ReactDOM   from 'react-dom/client'

import { HelmetProvider } from 'react-helmet-async'
import { BrowserRouter }  from 'react-router-dom'
import { GlobalStyle }    from 'styles/GlobalStyle'

import { Language } from 'main/Language'
import { DevelopmentPage } from 'components/ErrorsPage/DevelopmentPage.jsx'
import AppThemeProvider from 'theme/ThemeProvider.jsx'
import "./styles/fonts/fonts.css";
import "./styles/fonts/common.css"; 
import { Views } from 'pages/Views.jsx'

const strict = false

const Main = () => (
  <HelmetProvider>
    <BrowserRouter>
      <AppThemeProvider>
        <Views />
        <Language />
        <GlobalStyle />
      </AppThemeProvider>
    </BrowserRouter>
  </HelmetProvider>
)

const container = document.getElementById('root')

// Check if root is already created, to prevent creating multiple root instances
if (!container._rootInstance) {
  container._rootInstance = ReactDOM.createRoot(container)
}

// Render the app
container._rootInstance.render(
  strict
    ? <React.StrictMode>
        <Main />
      </React.StrictMode>
    : <Main />
)
